import { Component, Input } from '@angular/core';

@Component({
  selector: 'ngo-spinner-icon',
  templateUrl: './spinner-icon.component.html',
  styleUrls: ['./spinner-icon.component.scss']
})
export class SpinnerIconComponent {
  @Input() isLoading: boolean = false;
  @Input() size: string = 'large';
  constructor() { }

}
